import React from 'react';
import { fetcher } from '../../services/api';
import { CleanLocalDeliveryMethod } from '../../export-types/cleaned-types';
import useSWR from 'swr';
import Select from 'react-select';

type Props = {
  onChange?: (data: CleanLocalDeliveryMethod[]) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  value: CleanLocalDeliveryMethod[];
  roles?: string[];
  supplierId?: number;
};

export const LocalDeliveryMethodSelect = React.forwardRef(function (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  const { data = [] } = useSWR<Array<CleanLocalDeliveryMethod>>(
    {
      url: `/local-delivery-method`,
      params: {
        supplierId: props.supplierId,
      },
    },
    fetcher,
  );
  return (
    <Select
      placeholder={props.placeholder}
      onBlur={props.onBlur}
      options={data}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      isMulti={true}
      onChange={(methods) =>
        props.onChange ? props.onChange(methods.concat()) : undefined
      }
      onFocus={props.onFocus}
      value={props.value}
      // @ts-ignore
      ref={ref}
    />
  );
});
